// Central SEO configuration. Change SITE_URL here only.
export const SITE_URL = "https://torri.solar";

export const BRAND = "TORRI";
export const SITE_NAME = "TORRI · Beyond Ordinary Solar";
export const LOCALE = "it_IT";
export const TWITTER = ""; // add @handle if available

export const DEFAULT_OG_IMAGE = `${SITE_URL}/og/og-default.jpg`;
export const LOGO_URL = `${SITE_URL}/og/torri-icon.png`;

export const DEFAULT_TITLE =
  "TORRI · Fabbrica di Pannelli Fotovoltaici Made in Italy";
export const DEFAULT_DESCRIPTION =
  "TORRI progetta e produce in Italia pannelli fotovoltaici robusti, sicuri e longevi. Tecnologie brevettate X-CORE² e PRISMA 4.0 e impianti fotovoltaici chiavi in mano.";

export const DEFAULT_KEYWORDS = [
  "fabbrica di pannelli fotovoltaici Made in Italy",
  "pannelli fotovoltaici italiani",
  "moduli fotovoltaici prodotti in Italia",
  "pannelli fotovoltaici robusti",
  "pannelli fotovoltaici sicuri",
  "X-CORE²",
  "PRISMA 4.0",
  "impianti fotovoltaici chiavi in mano",
  "TORRI Solar",
];

// Organization / company data used for schema.org and contact points
export const ORG = {
  name: BRAND,
  legalName: "TORRI Beyond Ordinary Solar",
  url: SITE_URL,
  logo: LOGO_URL,
  telephone: "+39 030 6480034",
  email: "info@torrisolare.it",
  vatID: "03720770985",
  streetAddress: "Via Cremona 123",
  postalCode: "25025",
  addressLocality: "Manerbio",
  addressRegion: "BS",
  addressCountry: "IT",
  geo: { lat: 45.3503722, lng: 10.1389412 },
  openingHours: "Mo-Fr 08:30-18:00",
  mapsLink: "https://share.google/H631Mqyg0JaUWDRnD",
  mapsEmbed: "https://www.google.com/maps?q=Via%20Cremona%20123,%20Manerbio%20BS%2025025&output=embed",
  sameAs: [
    "https://www.instagram.com/torrisolare/",
    "https://www.youtube.com/channel/UCzahKuSnCNJ0TKoEyJ85vzg",
  ],
  foundingDate: "2007",
};

// Absolute URL helper for canonicals / sitemap
export const absUrl = (path = "/") => {
  if (!path) return SITE_URL;
  if (/^https?:\/\//i.test(path)) return path;
  return `${SITE_URL}${path.startsWith("/") ? "" : "/"}${path}`;
};
